import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauNumeroterAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	private isRejet: boolean;

	constructor(options: BaseLiquidationOptions & { isRejet?: boolean } = null) {
		super(options);
		this.label = options?.isRejet
			? 'Archiver ce bordereau de rejet'
			: 'Numéroter';
		this.type = BordereauActionType.NUMEROTER;
		this.isRejet = options?.isRejet;
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			numeroterModal: {
				visible: true,
				isArchive: this.isRejet,
			},
		},
	});

	/**
	 * Bordereau déjà numéroté par le job que la modale a lancé et suivi (BordereauNumeroterArchiverModal), relu avec
	 * ses journaux : il remplace celui de l'arbre.
	 */
	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.UPDATE,
		result: Promise.resolve(bordereau),
		shouldRefreshChildren: true,
	});
}

export default BordereauNumeroterAction;
